export default {"src":"/_next/static/image/public/images/flags/flag_216.e0153913e7f204a27a0039e1d422d55b.svg","height":16,"width":24};